import { useSyncExternalStore } from "react";
import { hideDailyLimitPaywall } from "./usePaywallDialog";

export type BuyKey = "day_pass" | "monthly" | "premium_day_pass" | "premium_monthly";

/**
 * Global store for the "buy with just your email" dialog (mounted once in Layout, like the paywall dialog).
 * Anyone who is not signed in and presses a buy button lands here instead of being sent to a sign-in page.
 */
let current: BuyKey | null = null;
const listeners = new Set<() => void>();
const notify = () => Array.from(listeners).forEach((l) => l());

export function openGuestCheckout(plan: BuyKey) {
  hideDailyLimitPaywall();
  current = plan;
  notify();
}
export function closeGuestCheckout() {
  current = null;
  notify();
}
export function useGuestCheckoutPlan(): BuyKey | null {
  return useSyncExternalStore(
    (onChange) => { listeners.add(onChange); return () => listeners.delete(onChange); },
    () => current,
  );
}
